import {countries} from './constants';

const halogenPools = [1, 2];
const biguanidePools = [3];
const saltPools = [12];
const mineralSpringsPools = [7];

const halogenSpas = [5, 6];
const biguanideSpas = [8];
const saltSpas = [13];


export function getProducts(country, chemicalBaseTypeID) {
  const poolType = [...order[country].keys()].find(types => types.includes(chemicalBaseTypeID));

  if (!poolType) {
    return undefined;
  }

  if (!chemicalBaseTypeID) {
    return [...order[country].values()]
      .map(list => list.map(x => products[country].find(y => y.id === x)));
  }

  return order[country].get(poolType)
    .map(x => products[country].find(y => y.id === x));
}


// Maps from arrays of chemical base type ids to arrays of suggested product ids
const order = {
  [countries.US]: new Map(),
  [countries.CA]: new Map(),
};

order[countries.US].set(halogenPools, [13, 1, 7, 6, 21, 4, 8, 3, 14, 10, 11, 9]);
order[countries.US].set(biguanidePools, [13, 7, 6, 21, 4, 3, 14, 10, 11]);
order[countries.US].set(saltPools, [12, 13,7, 6, 21, 4, 8, 3, 14, 10, 11, 9]);
order[countries.US].set(mineralSpringsPools, [13, 12, 2, 6, 21, 4, 14, 11, 9]);
order[countries.US].set(halogenSpas, [6, 17, 18, 5, 16, 19, 20, 15]);
order[countries.US].set(biguanideSpas, [6, 18]);
order[countries.US].set(saltSpas, [6, 17, 18, 5, 16, 19, 20, 15]);

order[countries.CA].set(halogenPools, [6, 5, 19, 3, 7, 2, 12, 9, 10, 8, 21]);
order[countries.CA].set(saltPools, [11, 6, 5, 19, 3, 7, 2, 12, 9, 10, 8, 21]);
order[countries.CA].set(mineralSpringsPools, [11, 1, 5, 19, 3, 12, 10, 8, 9]);
order[countries.CA].set(halogenSpas, [20, 15, 16, 4, 14, 18, 17, 13]);
order[countries.CA].set(saltSpas, [20, 15, 16, 4, 14, 18, 17, 13]);

const products = {
  [countries.US]: [
    {
      id: 1,
      wardenID: 28,
      name: 'Algae Complete',
      initialDose: volume => ({number: volume / 10000 * 8, unit: 'oz'}),
      maintenanceDose: volume => ({number: volume / 10000 * 1.5, unit: 'oz'}),
      clarity: true,
      comfort: true,
      tag: 'algae-complete',
    },
    {
      id: 2,
      wardenID: 21,
      name: 'Mineral Springs Stain And Scale',
      maintenanceDose: volume => ({number: volume / 5000, unit: 'qt'}),
      clarity: true,
      comfort: true,
      tag: 'mineral-springs-stain-scale',
    },
    {
      id: 3,
      wardenID: 60,
      name: 'Natural Clarifier',
      maintenanceDose: volume => ({number: volume / 5000, unit: 'qt'}),
      clarity: true,
      comfort: true,
      tag: 'natural-clarifier',
    },
    {
      id: 4,
      wardenID: 118,
      name: 'Natural Result',
      maintenanceDose: volume => ({number: volume / 2000, unit: 'oz'}),
      tag: 'natural-result',
    },
    {
      id: 5,
      wardenID: 16,
      name: 'Natural Spa Enzyme',
      initialDose: volume => ({number: volume / 50, unit: 'tbsp'}),
      maintenanceDose: volume => ({number: volume / 100, unit: 'oz'}),
      clarity: true,
      tag: 'natural-spa-enzyme',
    },
    {
      id: 6,
      wardenID: 119,
      name: 'Off The Wall',
      protection: true,
      tag: 'off-the-wall',
    },
    {
      id: 7,
      wardenID: 120,
      name: 'Optimizer Plus',
      initialDose: volume => ({number: volume / 10 * 35 * 0.57, unit: 'lb'}),
      tag: 'optimizer-plus',
    },
    {
      id: 8,
      wardenID: 62,
      name: 'Polysheen Blue',
      maintenanceDose: volume => ({number: volume / 5000, unit: 'oz'}),
      clarity: true,
      comfort: true,
      tag: 'polysheen-blue',
    },
    {
      id: 9,
      wardenID: 121,
      name: 'Pool Closing Complete',
      text: `suggested-products.us`,
      initialDose: volume => ({number: volume / 25000, unit: 'bottle'}),
      tag: 'pool-closing-complete',
    },
    {
      id: 10,
      wardenID: 31,
      name: 'Pool Complete',
      maintenanceDose: volume => ({number: volume / 10000 * 8, unit: 'oz'}),
      tag: 'pool-complete',
    },
    {
      id: 11,
      wardenID: 122,
      name: 'Pool Opening Complete',
      initialDose: volume => ({number: volume / 20000, unit: 'qt'}),
      tag: 'pool-opening-complete',
    },
    {
      id: 12,
      wardenID: 124,
      name: 'SaltScapes Cell Cleaner',
      tag: 'saltscapes-cell-cleaner',
    },
    {
      id: 13,
      wardenID: null,
      name: 'Skim Mor w/Myclex',
      protection: true,
      tag: 'skim-mor',
    },
    {
      id: 14,
      wardenID: 127,
      name: 'Smart Shield',
      maintenanceDose: volume => ({number: volume / 15000 * 8, unit: 'oz'}),
      tag: 'smart-shield',
    },
    {
      id: 15,
      wardenID: 128,
      name: 'Soft Soak® TRIO® Spa Kit - New',
      tag: 'soft-soak-trio',
    },
    {
      id: 16,
      wardenID: 148,
      name: 'Spa Complete',
      initialDose: volume => ({number: volume / 100, unit: 'capful'}),
      maintenanceDose: volume => ({number: volume / 250 * 0.5, unit: 'capful'}),
      clarity: true,
      comfort: true,
      tag: 'spa-complete',
    },
    {
      id: 17,
      wardenID: 133,
      name: 'Spa Stain and Scale Control',
      text: ``,
      initialDose: volume => ({number: volume / 150, unit: 'tbsp'}),
      maintenanceDose: volume => ({number: volume / 300, unit: 'oz'}),
      clarity: true,
      protection: true,
      tag: 'spa-stain-scale-control',
    },
    {
      id: 18,
      wardenID: 25,
      name: 'Spa System Flush',
      tag: 'spa-system-flush',
    },
    {
      id: 19,
      wardenID: null,
      name: 'Spa Water Clarifier',
      initialDose: volume => ({number: volume / 300, unit: 'tbsp'}),
      maintenanceDose: volume => ({number: volume / 600, unit: 'oz'}),
      clarity: true,
      comfort: true,
      tag: 'spa-water-clarifier',
    },
    {
      id: 20,
      wardenID: null,
      name: 'Spa Water Freshener',
      tag: 'spa-water-freshener',
    },
    {
      id: 21,
      wardenID: 136,
      name: 'Stow-Away',
      tag: 'stow-away',
    },
  ],
  [countries.CA]: [
    {
      id: 1,
      wardenID: 23,
      name: 'Mineral Springs Stain and Scale',
      maintenanceDose: volume => ({number: volume / 20, unit: 'L'}),
      protection: true,
      tag: 'mineral-springs-stain-scale',
    },
    {
      id: 2,
      wardenID: 60,
      name: 'Natural Clarifier',
      maintenanceDose: volume => ({number: volume / 10 * 15, unit: 'mL'}),
      clarity: true,
      tag: 'natural-clarifier',
    },
    {
      id: 3,
      wardenID: 118,
      name: 'Natural Result',
      initialDose: volume => ({number: volume / 10 * 120, unit: 'mL'}),
      maintenanceDose: volume => ({number: volume / 10 * 40, unit: 'mL'}),
      clarity: true,
      protection: true,
      tag: 'natural-result',
    },
    {
      id: 4,
      wardenID: 16,
      name: 'Natural Spa Enzyme',
      maintenanceDose: volume => ({number: volume / 1500 * 125, unit: 'mL'}),
      clarity: true,
      protection: true,
      tag: 'natural-spa-enzyme',
    },
    {
      id: 5,
      wardenID: 119,
      name: 'Off The Wall',
      protection: true,
      tag: 'off-the-wall',
    },
    {
      id: 6,
      wardenID: 120,
      name: 'Optimizer Plus',
      comfort: true,
      clarity: true,
      initialDose: volume => ({number: volume * 30 * 0.006, unit: 'kg'}),
      tag: 'optimizer-plus',
    },
    {
      id: 7,
      wardenID: 62,
      name: 'Polysheen Blue',
      maintenanceDose: volume => ({number: volume / 10 * 15, unit: 'mL'}),
      tag: 'polysheen-blue',
    },
    {
      id: 8,
      wardenID: 121,
      name: 'Pool Closing Complete',
      initialDose: volume => ({number: Math.ceil(volume / 95000), unit: 'bottle'}),
      clarity: true,
      tag: 'pool-closing-complete',
    },
    {
      id: 9,
      wardenID: 31,
      name: 'Pool Complete',
      text: ``,
      maintenanceDose: volume => ({number: volume / 30 * 120, unit: 'mL'}),
      protection: true,
      tag: 'pool-commplete',
    },
    {
      id: 10,
      wardenID: 122,
      name: 'Pool Opening Complete',
      initialDose: volume => ({number: Math.ceil(volume / 75000), unit: 'bottle'}),
      clarity: true,
      tag: 'pool-opening-complete',
    },
    {
      id: 11,
      wardenID: 124,
      name: 'SaltScapes Cell Cleaner',
      protection: true,
      tag: 'saltscapes-cell-cleaner',
    },
    {
      id: 12,
      wardenID: 127,
      name: 'Smart Shield',
      comfort: true,
      tag: 'smart-shield',
    },
    {
      id: 13,
      wardenID: 128,
      name: 'Soft Soak® TRIO® Spa Kit - New',
      initialDose: () => ({number: 1, unit: 'kit'}),
      comfort: true,
      tag: 'soft-soak-trio',
    },
    {
      id: 14,
      wardenID: 148,
      name: 'Spa Complete',
      initialDose: volume => ({number: Math.ceil(volume / 380), unit: 'capful'}),
      maintenanceDose: volume => ({number: Math.ceil(volume / 946 * 2) / 2, unit: 'capful'}),
      protection: true,
      tag: 'spa-complete',
    },
    {
      id: 15,
      wardenID: 133,
      name: 'Spa Stain and Scale Control',
      initialDose: volume => ({number: volume / 1000 * 25, unit: 'mL'}),
      maintenanceDose: volume => ({number: volume / 1000 * 15, unit: 'mL'}),
      protection: true,
      tag: 'spa-stain-scale-control',
    },
    {
      id: 16,
      wardenID: 184,
      name: 'Swirl Away Pipe Cleaner',
      protection: true,
      tag: 'swirl-away',
    },
    {
      id: 17,
      wardenID: 185,
      name: 'Swil Away II Surface Cleaner',
      protection: true,
      tag: 'swirl-away-ii',
    },
    {
      id: 18,
      wardenID: 157,
      name: 'Polysheen',
      text: ``,
      initialDose: volume => ({number: volume / 1000 * 20, unit: 'mL'}),
      maintenanceDose: volume => ({number: volume / 1000 * 10, unit: 'mL'}),
      clarity: true,
      tag: 'polysheen',
    },
    {
      id: 19,
      wardenID: 136,
      name: 'Stow-Away',
      text: ``,
      protection: true,
      tag: 'stow-away',
    },
    {
      id: 20,
      wardenID: 163,
      name: 'Filter Brite',
      text: ``,
      clarity: true,
      tag: 'filter-brite',
    },
    {
      id: 21,
      wardenID: 165,
      name: 'Clarifying Tabs',
      text: ``,
      clarity: true,
      tag: 'filter-brite',
    },
  ],
};

export default products;
